import { userService } from '@saucelabs/sl-util-axios';

export const getUsers = ({ limit = 99999, offset = 0 } = {}) => (
  userService.get('/v1/users/', { params: { limit, offset } })
);
